import { render, staticRenderFns } from "./PermissionsTablePage.vue?vue&type=template&id=7154c4da&scoped=true"
import script from "./PermissionsTablePage.vue?vue&type=script&lang=js"
export * from "./PermissionsTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7154c4da",
  null
  
)

export default component.exports